export default {
  path: 'https://arco.design',
  name: 'arcoWebsite',
  meta: {
    locale: 'menu.arcoWebsite',
    icon: 'icon-link',
    requiresAuth: true,
    order: 8,
  },
};
